var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8841 3.02081L15.1812 2.99165C15.0812 2.99165 15.0001 2.91732 15.0001 2.81665V1.6406C15.0001 1.2379 14.6756 0.833313 14.2754 0.833313C13.8752 0.833313 13.5508 1.2379 13.5508 1.6406V4.99998C13.5501 5.83331 12.1751 5.83331 12.174 4.99998V3.3854C12.174 3.18404 12.0118 3.02081 11.8117 3.02081L7.46385 2.99477C7.36408 2.99477 7.28309 2.9136 7.28269 2.81321V1.53644C7.28269 1.13373 6.95826 0.833313 6.55805 0.833313C6.15785 0.833313 5.83341 1.13373 5.83341 1.53644V4.99998C5.83341 5.83331 4.58341 5.83331 4.5653 4.99998V3.3854C4.5653 3.18404 4.40308 3.02081 4.20298 3.02081H3.11602C2.31561 3.02081 1.66675 3.67373 1.66675 4.47915V16.875C1.66675 17.6804 2.31561 18.3333 3.11602 18.3333H16.8841C17.6846 18.3333 18.3334 17.6804 18.3334 16.875V4.47915C18.3334 3.67373 17.6846 3.02081 16.8841 3.02081ZM16.3158 16.6667H3.68421C3.49043 16.6667 3.33333 16.5088 3.33333 16.3141V7.85256C3.33333 7.65785 3.49043 7.5 3.68421 7.5H16.3158C16.5096 7.5 16.6667 7.65785 16.6667 7.85256V16.3141C16.6667 16.5088 16.5096 16.6667 16.3158 16.6667Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4d9b9592.svg";
export { ForwardRef as ReactComponent };